




































import {
  Consultor,
  ConsultoresService,
  EnvioEmails,
} from "@/services/consultores.service";
import Confirm from "@/shared/components/confirm.vue";
import DataTable from "@/shared/components/data-table.vue";
import GlobalMixin from "@/shared/mixins/globalMixin";
import { mixins } from "vue-class-component";
import { Component, Prop } from "vue-property-decorator";
import PlanosAba from "../tables/PlanosAba.vue";

@Component({
  components: {
    DataTable,
    Confirm,
    PlanosAba,
  },
})
export default class EnvioEmail extends mixins(GlobalMixin) {
  @Prop() idConsultor!: number;
  consultor: Consultor | null = null;
  loading = false;
  msgEmail: string | null = "";
  showSucess?: boolean = false;
  showError?: boolean = false;
  envioEmails: EnvioEmails = {
    compromissos: false,
    novidades: false,
    indicacoes: false,
    whatsapp: false,
  };

  mounted() {
    this.fetchEnvioEmail();
    this.fetchConsultoresSelecionado(this.idConsultor);
  }

  async fetchEnvioEmail() {
    this.loading = true;
    try {
      const preferencia = await ConsultoresService.ObterPreferencia(
        this.idConsultor
      );
      this.envioEmails.compromissos = preferencia.receberLembretes;
      this.envioEmails.novidades = preferencia.receberNovidades;
      this.envioEmails.indicacoes = preferencia.receberNotificacaoIndicaco;
      this.envioEmails.whatsapp = preferencia.receberWhatsapp;

      console.log(preferencia, this.envioEmails);
    } finally {
      this.loading = false;
    }
  }

  async fetchConsultoresSelecionado(idConsultor: number) {
    this.loading = true;
    try {
      this.consultor = await ConsultoresService.ObterDadosConsultor(
        idConsultor
      );
    } finally {
      this.loading = false;
    }
  }

  public atualizarConsultorSelecionado() {
    this.fetchConsultoresSelecionado(this.idConsultor);
  }

  async ConfiguraEnvioEmails() {
    this.startLoader();
    const msg = await ConsultoresService.ConfiguraEnvioEmails(
      this.idConsultor,
      this.envioEmails
    ).finally(this.stopLoader);
    if (msg) {
      this.msgEmail = "Configuração de Envio de E-mails/WhatsApp atualizada";
      this.showSucess = true;
      setTimeout(this.fechaAlertaDados, 5000);
    } else {
      this.msgEmail =
        "Aconteceu um problema na configuração de Envio de E-mails/WhatsApp.";
      this.showError = true;
      setTimeout(this.fechaAlertaDados, 5000);
    }
  }
  fechaAlertaDados() {
    this.showSucess = false;
    this.showError = false;
  }
}
